import React from "react"
import InnerHTML from 'dangerously-set-html-content'
import IntersectionVisible from 'components/IntersectionVisible'

const CustomHtmlStep = ({ breakId, step, onEngage = function() {}, onAwardPoints = function() {}, userType, service, nextStepButton }) => {


    const handleIsOnScreen = (isIntersecting) => {
        if (isIntersecting) {
            onEngage()
			onAwardPoints()
        }
    }

	// Would be nice if we could wrap rules in a SCSS selector like `.step-${step.id} { ... }` to isloate them 
	const inlineStyle = `
		${step.customCss}
	`
	
	return (
		<section className={`custom-html-step`}>
			<div className={`step-content with-shadow`}>
				<IntersectionVisible active={true} options={{
									threshold: 0.4,
								}} onIntersect={handleIsOnScreen}>
					<style
						dangerouslySetInnerHTML={{
						__html: inlineStyle,
						}}
					/>
					<InnerHTML html={step.customHtml} />
				</IntersectionVisible>
				{nextStepButton}
			</div>
		</section>
	)
}

export default CustomHtmlStep
